<template>
    <div>
        <menu-bar v-if="menu" />
        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">
                <ol class="breadcrumb">
                    <li>
                        <a href="#/"
                            ><i class="fa fa-home" aria-hidden="true"></i>
                            INICIAL</a
                        >
                    </li>
                    <li>
                        <a href="#/caixas-cto"
                            ><i class="fa fa-suitcase" aria-hidden="true"></i>
                            CAIXAS CTO</a
                        >
                    </li>
                    <li class="active">CADASTRO DE CAIXAS CTO</li>
                </ol>

                <form v-if="caixa" class="form-horizontal">
                    <go-back v-if="menu" /> &nbsp;
                    <button
                        v-if="user.level < 5"
                        :disabled="!caixa.fibra._id || !caixa.splitter2._id"
                        type="button"
                        class="btn btn-success"
                        @click="save()"
                    >
                        <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR
                        CAIXAS CTO
                    </button>
                    <br v-if="menu" /><br v-if="menu" />
                    <div class="panel panel-info">
                        <!-- Default panel contents -->
                        <div class="panel-heading">
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                            DADOS BÁSICOS
                        </div>
                        <div class="panel-body">
                            <div class="form-group" v-if="caixa._id">
                                <div class="col-sm-3">
                                    <label for="numero" class="control-label"
                                        >NÚMERO</label
                                    >
                                    <div class="input-group">
                                        <input
                                            id="numero"
                                            :disabled="disabledNumber"
                                            v-model.number="caixa.numero"
                                            type="number"
                                            class="form-control text-right"
                                        />
                                        <span class="input-group-btn">
                                            <button
                                                @click="
                                                    disabledNumber = !disabledNumber
                                                "
                                                class="btn btn-default btn-success"
                                                type="button"
                                            >
                                                <i
                                                    class="fa fa-edit"
                                                    aria-hidden="true"
                                                ></i>
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-3">
                                    <label for="nome" class="control-label"
                                        >NOME CAIXAS CTO</label
                                    >
                                    <input
                                        id="nome"
                                        :value="
                                            caixa.numero
                                                ? 'CTO-' + caixa.numero
                                                : null
                                        "
                                        disabled
                                        type="text"
                                        class="form-control"
                                    />
                                </div>

                                <div class="col-sm-3">
                                    <label
                                        :class="{
                                            'text-danger': !caixa.fibra._id
                                        }"
                                        for="portas"
                                        class="control-label"
                                        >FIBRA DA CAIXA</label
                                    >
                                    <select
                                        id="portas"
                                        v-model="caixa.fibra._id"
                                        class="form-control"
                                    >
                                        <option
                                            v-for="p of fibras"
                                            v-bind:key="p._id"
                                            :value="p._id"
                                            >{{ p.porta_pon.nome }} /
                                            {{ p.nome }}</option
                                        >
                                    </select>
                                </div>

                                <div class="col-sm-3">
                                    <label for="splitter1" class="control-label"
                                        >SPLITTER 1</label
                                    >
                                    <select
                                        id="splitter1"
                                        v-model="caixa.splitter1._id"
                                        class="form-control"
                                    >
                                        <option :value="null"
                                            >NENHUM SPLITTER</option
                                        >
                                        <option
                                            v-for="p of splitters"
                                            v-bind:key="p._id"
                                            :value="p._id"
                                            >SPL-{{ p.potencia }}</option
                                        >
                                    </select>
                                </div>

                                <div class="col-sm-3">
                                    <label
                                        :class="{
                                            'text-danger': !caixa.splitter2._id
                                        }"
                                        for="splitter2"
                                        class="control-label"
                                        >SPLITTER 2</label
                                    >
                                    <select
                                        id="splitter2"
                                        v-model="caixa.splitter2._id"
                                        class="form-control"
                                    >
                                        <option :value="null"
                                            >NENHUM SPLITTER</option
                                        >
                                        <option
                                            v-for="p of splitters"
                                            v-bind:key="p._id"
                                            :value="p._id"
                                            >SPL-{{ p.potencia }}</option
                                        >
                                    </select>
                                </div>

                                <div class="col-sm-3">
                                    <label for="sinal" class="control-label"
                                        >SINAL DA CTO</label
                                    >
                                    <input
                                        v-mask="'-00.00'"
                                        id="sinal"
                                        v-model.number="caixa.sinal"
                                        type="text"
                                        class="form-control"
                                    />
                                </div>

                                <div class="col-sm-3">
                                    <label for="vlan" class="control-label"
                                        >V-LAN</label
                                    >
                                    <input
                                        id="vlan"
                                        readonly
                                        :value="
                                            caixa.numero
                                                ? 'vlan-CTO-' + caixa.numero
                                                : null
                                        "
                                        type="text"
                                        class="form-control"
                                    />
                                </div>

                                <div class="col-sm-3">
                                    <label for="portas" class="control-label">PORTAS NA CTO</label>
                                    <input
                                        id="portas"
                                        v-model.number="caixa.portas"
                                        type="number"
                                        class="form-control"
                                    />
                                </div>

                                <div class="col-sm-3">
                                    <label for="portas" class="control-label">LOCAL DA INSTALAÇÃO</label>
                                    <input
                                        id="local"
                                        v-model="caixa.local"
                                        type="text"
                                        class="form-control"
                                    />
                                </div>

                                <div class="col-sm-12">
                                    <label for="obs" class="control-label"
                                        >OBS DA CTO</label
                                    >
                                    <textarea
                                        id="obs"
                                        v-model="caixa.obs"
                                        rows="5"
                                        class="form-control"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <place :place.sync="caixa.place" :height="'500px'" />

                    <div class="form-group">
                        <div class="col-sm-10">
                            <button
                                v-if="user.level < 5"
                                :disabled="
                                    !caixa.fibra._id || !caixa.splitter2._id
                                "
                                type="button"
                                class="btn btn-success"
                                @click="save()"
                            >
                                <i
                                    class="fa fa-floppy-o"
                                    aria-hidden="true"
                                ></i>
                                SALVAR CAIXAS CTO
                            </button>
                            &nbsp;
                            <go-back v-if="menu" />
                        </div>
                    </div>

                    <br />
                    <div v-if="caixa._id" class="panel panel-info">
                        <!-- Default panel contents -->
                        <div class="panel-heading">
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                            CAIXAS PAC-PON NESTA CTO
                        </div>
                        <div class="panel-body">
                            <table
                                id="mytable"
                                class="table table-bordred table-striped"
                            >
                                <thead>
                                    <tr>
                                        <th
                                            style="text-align: center;width: 100px"
                                        >
                                            PON ID
                                        </th>
                                        <th>NOME</th>
                                        <th
                                            style="text-align: center;width: 140px"
                                        >
                                            CTO
                                        </th>
                                        <th
                                            style="text-align: center;width: 140px"
                                        >
                                            FIBRA
                                        </th>
                                        <th
                                            style="text-align: center;width: 100px"
                                        >
                                            AÇÕES
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="r in ctos" v-bind:key="r._id">
                                        <td>{{ r.porta_pon.pon_id }}</td>
                                        <td>{{ r.nome }}</td>
                                        <td class="text-center">
                                            CTO-{{ r.cto.numero }}
                                        </td>
                                        <td class="text-center">
                                            FO-{{ r.fibra.numero }}
                                        </td>
                                        <td style="text-align: center">
                                            <a
                                                :href="
                                                    '#/caixa-pacpon/add/' +
                                                        r._id
                                                "
                                                class="btn btn-primary btn-xs"
                                            >
                                                ABRIR
                                                <i
                                                    class="fa fa-angle-double-right"
                                                    aria-hidden="true"
                                                ></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <br />
                    <list-clientes-no-cto
                        :_id="caixa._id"
                        v-if="caixa && caixa._id"
                    />

                    <br />
                    <list-clientes-ftth-no-cto
                        :_id="caixa._id"
                        v-if="caixa && caixa._id"
                    />
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { CaixaCTO, Fibra, Splitter, CaixaPacPon } from "../../../class/index";
import { Place } from "../../../components/exports";
import ListClientesNoCto from "../../../components/lists/ListClientesNoCTO";
import ListClientesFtthNoCto from "../../../components/lists/ListClientesFtthNoCTO";
import GoBack from "../../../components/buttons/goback";

export default {
    components: {
        Place,
        GoBack,
        ListClientesNoCto,
        ListClientesFtthNoCto
    },
    data() {
        return {
            disabledNumber: true,
            menu: true,
            user: null,
            caixa: null,
            fibras: [],
            splitters: [],
            ctos: []
        };
    },
    computed: {
        _id() {
            return this.$route.params.id;
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.loadFibras();
        this.loadSplitters();
        if (this.$route.query.disable_menu === "1") {
            this.menu = false;
        }
        if (this._id) {
            this.loadPonto(this.$route.params.id);
        } else if (this.$route.params.lat && this.$route.params.lng) {
            this.caixa = CaixaCTO.create();
            this.caixa.place = [
                Number(this.$route.params.lng),
                Number(this.$route.params.lat)
            ];
            this.menu = false;
        } else {
            this.caixa = CaixaCTO.create();
        }
    },
    beforeDestroy() {
        console.log("ponto off");
    },
    methods: {
        async loadPonto() {
            let caixa = await CaixaCTO.byID(this._id);
            if (!caixa.obs) {
                caixa.obs = null;
            }
            this.caixa = caixa;
            this.loadPacPons();
        },
        async loadFibras() {
            this.fibras = await Fibra.all();
        },
        async loadSplitters() {
            this.splitters = await Splitter.all();
        },
        loadPacPons() {
            CaixaPacPon.byCTO(this._id)
                .then(rows => (this.ctos = rows))
                .catch(err => console.log(err));
        },
        save() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o ponto?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            CaixaCTO.save(this.caixa)
                                .then(() => {
                                    resolve();
                                    if (this.menu) {
                                        this.$router.push({
                                            path: "/caixas-cto"
                                        });
                                    } else {
                                        window.close();
                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
